import React, { FC } from 'react';

import { Stack, Text } from '@chakra-ui/react';

import { KnowledgeBaseDrawer } from 'components/DataDisplay/KnowledgeBase/BaseComponents/KnowledgeBaseDrawer';
import { IconTypes } from 'components/Icons';

export const LearnMoreAboutDataPolicy: FC = () => {
  return (
    <KnowledgeBaseDrawer
      knowledgeBaseKey="data_policy"
      headerTitle="Data Policy"
      iconType={IconTypes.Documents}
      body={
        <Stack spacing={10}>
          <Text>
            Data policy provides a way to achieve least privilege management by
            combining granular definitions for access control, dynamic data
            masking and specific data sources that hold data that are related or
            correlated to drive business value.
          </Text>
          <Text>
            Data policy defines what data sources (logically grouped) as Data
            Groups can be accessed by whom (users, groups and roles) and how
            data is presented to them based on their persona using dynamic
            masking. Our data policies leverage Ariksa’s data classification
            capabilities that identifies sensitive data across structured,
            unstructured and semi-structured data sources and applies
            appropriate labels that can be use to define data policies.
          </Text>
          <Text>
            Data policies can be created for data sources in the cloud (such as
            AWS S3, AWS RDS) and SaaS (such as Snowflake).
          </Text>
        </Stack>
      }
    />
  );
};
